import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/checkout';
interface CtaButtonProps {
  label: string;
  subLabel?: string;
  variant?: 'gold' | 'outline';
  id?: string;
}
export function CtaButton({
  label,
  subLabel,
  variant = 'gold',
  id
}: CtaButtonProps) {
  const base = 'group inline-flex w-full max-w-xl items-center justify-center gap-2 rounded-xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-200 ease-out focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold-500/50 active:scale-[0.985] sm:text-base';
  const styles = variant === 'gold' ? 'bg-gold-500 text-navy-950 shadow-[0_10px_30px_-10px_rgba(201,162,75,0.8)] hover:bg-gold-400' : 'border-2 border-gold-500 bg-transparent text-gold-400 hover:bg-gold-500 hover:text-navy-950';
  return <div className="flex w-full flex-col items-center" id={id} data-id="element-28" data-mp="15areof8thbm1">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${styles}`} data-id="element-29" data-mp="35xo0oxojy8ky">
        <span data-id="element-30" data-mp="39z9jeznrph32">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="3a0kn6zh7qou6" />
      </a>
      {subLabel ? <p className="mt-3 text-center text-[11px] font-medium uppercase tracking-[0.12em] text-slate-400 sm:text-xs" data-id="element-32" data-mp="3jukrx08l1s2d">
          {subLabel}
        </p> : null}
    </div>;
}